<div class="main-container">
  @if (isExistingPath) {
    <div class="banner">
      <img src="assets/icon/info-banner.svg" alt="" />
      <p>
        {{ "REGISTER.VERIFY_EMAIL.BANNER.PARAGRAPH_1" | translate }}
        <b>{{ "REGISTER.VERIFY_EMAIL.BANNER.BOLD_1" | translate }}</b>
        ,
        {{ "REGISTER.VERIFY_EMAIL.BANNER.AND" | translate }}
        <b>{{ "REGISTER.VERIFY_EMAIL.BANNER.BOLD_2" | translate }}</b>
        ,
        {{ "REGISTER.VERIFY_EMAIL.BANNER.PARAGRAPH_2" | translate }}
        <a href="https://cariloop.com/privacy-policy">
          {{ "REGISTER.VERIFY_EMAIL.BANNER.PRIVACY" | translate }}
        </a>
        {{ "REGISTER.VERIFY_EMAIL.BANNER.AND" | translate }}
        <a href="https://cariloop.com/terms-of-service">
          {{ "REGISTER.VERIFY_EMAIL.BANNER.TERMS" | translate }}
        </a>
        .
        {{ "REGISTER.VERIFY_EMAIL.BANNER.PARAGRAPH_3" | translate }}
      </p>
    </div>
  }
  <div class="description-container">
    <h1 class="title">
      {{ "REGISTER.VERIFY_EMAIL.VERIFY" | translate }}
    </h1>
    <p class="text">
      {{
        "REGISTER.VERIFY_EMAIL.DESCRIPTION"
          | translate: { email: account.email }
      }}
    </p>
  </div>
  <form [formGroup]="form" class="form-container">
    @if (error) {
      <div class="error-container">
        @if (error === "system-error") {
          <c-banner
            class="error-banner system-error-banner"
            [style]="'error'"
            [inline]="false"
            [message]="
              'REGISTER.GENERIC_FORM.ERRORS.GENERIC-GATEWAY-TIMEOUT' | translate
            "
            [showCloseButton]="false"
          ></c-banner>
        }
        @if (error === "generic") {
          <c-banner
            iconPositionX="top"
            [style]="'error'"
            [inline]="false"
            class="error-banner generic-error-banner"
          >
            <div class="banner-message">
              <span>
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-1"
                    | translate
                }}
              </span>
              <span>
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-2"
                    | translate
                }}
              </span>
              <a class="banner-link" href="mailto:support@cariloop.com">
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-3"
                    | translate
                }}
              </a>
            </div>
          </c-banner>
        }
        @if (error === "invalid-code") {
          <c-banner
            class="error-banner invalid-code-error-banner"
            [style]="'error'"
            [inline]="false"
            [message]="'REGISTER.VERIFY_EMAIL.ERRORS.INVALID_CODE' | translate"
            [showCloseButton]="false"
          ></c-banner>
        }
      </div>
    }
    <div class="input-container">
      <div class="input">
        <c-input-text
          inputID="verify-code"
          label="{{ 'REGISTER.VERIFY_EMAIL.INPUT' | translate }}"
          [disabled]="isLoading"
          formControlName="code"
          name="code"
          type="number"
          [showCounterArrows]="false"
        >
        </c-input-text>
        <div role="alert">
          @if ((code.dirty || code.touched) && !code.valid) {
            <span class="verify-code__input-error">
              @if (code.errors?.required) {
                <p>
                  {{ "REGISTER.VERIFY_EMAIL.ERRORS.REQUIRED" | translate }}
                </p>
              }
              @if (code.errors?.minlength || code.errors?.maxlength) {
                <p>
                  {{ "REGISTER.VERIFY_EMAIL.ERRORS.LENGTH" | translate }}
                </p>
              }
            </span>
          }
        </div>
      </div>
    </div>
    @if (!isLoading) {
      <button
        cari-button
        type="submit"
        [ngClass]="{
          'verify-email-button': true,
          'full-button': (isMobileWidth$ | async),
          'brand-submit-btn': true,
        }"
        data-shape="squared"
        data-type="neutral"
        data-style="fill"
        data-size="x-large"
        [disabled]="!form.valid"
        (click)="verifyEmail()"
      >
        {{ "REGISTER.VERIFY_EMAIL.CONTINUE" | translate }}
      </button>
    }
    @if (isLoading) {
      <mat-spinner diameter="40" />
    }
  </form>
  <div class="resend-container">
    <p class="resend">
      {{ "REGISTER.VERIFY_EMAIL.RESEND.TEXT" | translate }}
      <button class="link" (click)="resendCode()">
        {{ "REGISTER.VERIFY_EMAIL.RESEND.LINK_1" | translate }}
      </button>
    </p>
    <p class="resend">
      {{ "REGISTER.VERIFY_EMAIL.RESEND.WRONG_EMAIL" | translate }}
      <button class="link" (click)="reEnterEmail()">
        {{ "REGISTER.VERIFY_EMAIL.RESEND.LINK_2" | translate }}
      </button>
    </p>
  </div>
  <app-toast
    id="toast"
    [message]="toastProperties.toastMessage | translate"
    [showsToast]="toastProperties.showToast"
    [state]="toastProperties.toastType"
  ></app-toast>
</div>
